import { DealbreakerQuestion, DealbreakerAnswer } from "@/types/dealbreaker";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { AlertCircle } from "lucide-react";

interface TheirAnswersCardProps {
  myQuestions: DealbreakerQuestion[];
  theirAnswers: DealbreakerAnswer[];
}

export function TheirAnswersCard({
  myQuestions,
  theirAnswers,
}: TheirAnswersCardProps) {
  // Don't render if no questions
  if (myQuestions.length === 0) {
    return null;
  }

  const hasAnsweredAll = theirAnswers.length === myQuestions.length;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Their Answers to Your Dealbreaker Questions</CardTitle>
        <CardDescription>
          {hasAnsweredAll
            ? "They have answered all of your dealbreaker questions"
            : "Waiting for them to answer your dealbreaker questions"}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        {myQuestions.map((question, index) => {
          const answer = theirAnswers.find((a) => a.question_id === question.id);

          return (
            <div key={question.id} className="space-y-2">
              <div className="flex items-start gap-2">
                <span className="font-semibold text-primary text-sm">Q{index + 1}:</span>
                <p className="text-sm font-medium flex-1">{question.question_text}</p>
              </div>
              <div className="flex items-start gap-2 ml-6">
                <span className="font-semibold text-muted-foreground text-sm">A:</span>
                {answer ? (
                  <p className="text-sm text-muted-foreground flex-1">{answer.answer_text}</p>
                ) : (
                  <p className="text-sm text-muted-foreground flex-1 italic flex items-center gap-1">
                    <AlertCircle className="h-3 w-3" />
                    Not yet answered
                  </p>
                )}
              </div>
              {index < myQuestions.length - 1 && <Separator className="mt-4" />}
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
}
